
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';

  @Component({
    components: {ImageSelector},
  })
  export default class DlgTrainingDelete extends Vue {
    @Prop({type: Object, default: null}) private training!: any;

    @Action('admin/trainings/remove') private deleteTraining!: any;
    @Action('admin/trainings/read') private readTrainings!: any;
    @Getter('common/rules/all') private rules!: any;

    private dialog: boolean = false;
    private loading: boolean = false;

    private async del() {
      this.loading = true;
      await this.deleteTraining(this.training);
      await this.readTrainings();
      this.dialog = false;
      this.loading = false;
    }
  }
